import React from "react";
import { Apple, Play } from "lucide-react";

export function AppStoreBadge({ testId = "cta-app-store" }) {
  return (
    <a
      href="#"
      data-testid={testId}
      className="group flex items-center gap-3 bg-white text-black px-5 py-3 rounded-full hover:bg-[#D4F34A] transition active:scale-95"
    >
      <Apple size={22} strokeWidth={2} />
      <div className="text-left leading-tight">
        <div className="text-[10px] uppercase tracking-widest opacity-70">
          Download on the
        </div>
        <div className="font-display text-lg uppercase tracking-tight">
          App Store
        </div>
      </div>
    </a>
  );
}

export function PlayStoreBadge({ testId = "cta-play-store" }) {
  return (
    <a
      href="#"
      data-testid={testId}
      className="group flex items-center gap-3 bg-transparent text-white px-5 py-3 rounded-full border border-white/30 hover:border-[#D4F34A] hover:text-[#D4F34A] transition active:scale-95"
    >
      <Play size={20} strokeWidth={2} fill="currentColor" />
      <div className="text-left leading-tight">
        <div className="text-[10px] uppercase tracking-widest opacity-70">
          Get it on
        </div>
        <div className="font-display text-lg uppercase tracking-tight">
          Google Play
        </div>
      </div>
    </a>
  );
}
